import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  imageClassName?: string;
}

const BrandLogo = ({ className, imageClassName }: BrandLogoProps) => {
  return (
    <div className={cn("flex items-center", className)}>
      <img
        alt="Sana Pilates"
        className={cn("h-16 w-auto object-contain", imageClassName)}
        src="/lovable-uploads/logo-sana-pilates.webp"
        width={348}
        height={232}
        loading="eager"
        decoding="async"
        sizes="(max-width: 640px) 282px, 348px"
        // @ts-expect-error fetchpriority is a valid HTML attribute
        fetchpriority="high"
      />
    </div>);

};

export default BrandLogo;